import { ICategoriesState } from './CategoriesInterfaces';

const CATEGORIES_INITIAL_STATE: ICategoriesState = {
  data: [],
  isCreating: false,
  isLoading: false,
  meta: {
    message: '',
  },
  pagination: {
    page: 1,
    perPage: 20,
    total: 0,
    totalPages: 0,
  },
};

export default CATEGORIES_INITIAL_STATE;
